// Types
import { LinkProps } from '../../types/actions/links';

export const validate = ({ icon, variant }: LinkProps) => {
  if (icon && !icon.position && variant !== 'icon-button') {
    throw new Error(
      'Ensure the icon position is provided when setting an icon defintion without the `icon-button` variant type',
    );
  }
};
